export default function inputValidation(event, fieldCode, fieldType) {
  const raw = event?.target?.value;
  const newValue = typeof raw === 'string' ? raw.trim() : String(raw || '').trim();

  const maxLength = fieldType?.includes('TEXT_FIELD_')
    ? parseInt(fieldType.split('_')[2], 10)
    : fieldType === 'TEXT_AREA'
    ? 500000
    : fieldType === 'NUMBER_FIELD' || fieldType === 'Number' || fieldType === 'AMOUNT_FIELD'
    ? 20
    : fieldType === 'TEXT_FIELD' || fieldType === 'String'
    ? 100
    : 10000;

  let disallowedChars = [
    '&',
    '$',
    '#',
    '^',
    '*',
    '(',
    ')',
    '?',
    '/',
    '{',
    '}',
    '+',
    '=',
    '~',
    '`',
    '!',
    ':',
    ';',
    '@',
    '_',
    '.',
    '%',
    '[',
    ']',
    "'",
    '"',
    ' ',
    '-'
  ];

  // Exceptions for certain field types
  if (fieldCode === 'EMAIL') {
    disallowedChars = disallowedChars.filter((char) => !'@!#$%&*+-/=?^_`{|}~,.'.includes(char));
  }
  if (fieldType?.includes('TEXT_AREA')) {
    disallowedChars = disallowedChars.filter((char) => !'_-%&()?,.:$!#^ '.includes(char));
  }
  if (
    (fieldType?.includes('TEXT_FIELD') || fieldType === 'String' || fieldType === 'TEXT_AREA') &&
    !fieldType?.includes('TEXT_AREA') &&
    fieldCode !== 'EMAIL'
  ) {
    disallowedChars = disallowedChars.filter((char) => !'%&()?,.:$!#^- '.includes(char));
  }
  if (fieldType === 'ALPHABET') {
    disallowedChars = disallowedChars.filter((char) => !' '.includes(char));
  }
  if (fieldType === 'DATE_FIELD' || fieldType === 'Date') {
    disallowedChars = disallowedChars.filter((char) => char !== '-');
  }
  if (fieldType === 'NUMBER_FIELD' || fieldType === 'Number') {
    if (/^-?\d*(\.\d+)?$/.test(newValue) && newValue !== '-') {
      disallowedChars = disallowedChars.filter((char) => char !== '-');
    }
  }
  if (fieldType === 'INTEGER' || fieldType === 'Integer') {
    disallowedChars.push('.');
    const isValidNumberWithPrefix = /^[-+]?\d*$/.test(newValue);
    if (isValidNumberWithPrefix) {
      disallowedChars = disallowedChars.filter((char) => char !== '+' && char !== '-');
    }
  }
  if (fieldType === 'AMOUNT_FIELD') {
    disallowedChars = disallowedChars.filter((char) => !'.,'.includes(char));
  }

  let newError = '';

  // Generic checks
  if (
    ((fieldType?.includes('TEXT_FIELD') || fieldType === 'String' || fieldType === 'TEXT_AREA') &&
      newValue.length > maxLength) ||
    ((fieldType === 'NUMBER_FIELD' || fieldType === 'Number' || fieldType === 'AMOUNT_FIELD') &&
      newValue.toString().length > maxLength)
  ) {
    newError = `Input cannot exceed ${maxLength} characters.`;
  }
  // if (disallowedChars.some((char) => newValue.includes(char))) {
  //   newError = 'Input contains invalid characters.';
  // }
  if (!/^-?\d*\.?\d*$/.test(newValue) && (fieldType === 'NUMBER_FIELD' || fieldType === 'Number')) {
    newError = 'Enter numbers only.';
  }
  if (!/^-?(?!,$)\d*\.?\d*(,\d*)*\.?\d*$/.test(newValue) && fieldType === 'AMOUNT_FIELD') {
    newError = 'Invalid amount format.';
  }
  if (fieldType === 'ALPHABET') {
    if (!/^[a-zA-Z ]*$/.test(newValue)) {
      newError = 'Enter alphabets only.';
    } else if (newValue.length > 100) {
      newError = 'Text cannot exceed 100 letters.';
    }
  }
  if (fieldType === 'TEXT_AREA') {
    if (newValue.length > 100) {
      newError = 'Text cannot exceed 100 letters.';
    }
  }
  if (/<\/?[^>]*>/.test(newValue)) {
    newError = 'Input cannot contain HTML/XML-like tags.';
  }

  // Field-specific validation

  if (!newError && newValue) {
    if (fieldCode === 'EMAIL') {
      const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (!emailRegex.test(newValue)) {
        return 'Please enter a valid email address';
      }
      // Additional checks for common email mistakes
      if (newValue.includes('..')) {
        return 'Email cannot contain consecutive dots';
      }
      if (newValue.startsWith('.') || newValue.endsWith('.')) {
        return 'Email cannot start or end with a dot';
      }
      if (newValue.length > 100) {
        return 'Email cannot exceed 100 characters';
      }
      return true;
    }
    if (fieldCode === 'MOBILE') {
      // Check if it's exactly 10 digits
      if (!/^\d{10}$/.test(newValue)) {
        return 'Mobile number must be exactly 10 digits';
      }
      // Check if it starts with 6-9
      if (!/^[6-9]/.test(newValue)) {
        return 'Mobile number must start with 6, 7, 8 or 9';
      }
      // Check for repeated digits (optional)
      if (/^(\d)\1{9}$/.test(newValue)) {
        return 'Invalid mobile number pattern';
      }
      return true;
    }

    if (fieldCode === 'AADHAR') {
      if (newValue.length > 12) return 'Aadhaar must be exactly 12 digits.';
      if (/[^\d]/.test(newValue)) return 'Aadhaar must contain only numbers.';
      if (newValue.length !== 12) return 'Aadhaar must be exactly 12 digits.';
      return true;
    }
    if (fieldCode === 'FILE_NO') {
      if (!/^[a-zA-Z0-9_\/-]+$/.test(newValue)) {
        return 'File number can only contain letters, numbers, hyphens, underscores and forward slashes';
      }
      if (newValue.length > 50) {
        return 'File number cannot exceed 50 characters';
      }
      return true;
    }
    if (fieldCode === 'AGE') {
      const age = parseInt(newValue, 10);
      if (Number.isNaN(age)) {
        return 'Please enter a valid age';
      }
      if (age < 18) {
        return 'Age must be at least 18';
      }
      if (age > 100) {
        return 'Age cannot be more than 100';
      }
      return true;
    }
    if (fieldCode === 'CIBIL') {
      const score = parseInt(newValue, 10);
      if (Number.isNaN(score)) {
        return 'Please enter a valid CIBIL score';
      }
      if (score < 300 || score > 900) {
        return 'CIBIL score must be between 300 and 900';
      }
      return true;
    }
    if (fieldCode === 'INTEREST_RATE') {
      const rate = parseFloat(newValue);
      if (Number.isNaN(rate)) {
        return 'Please enter a valid interest rate';
      }
      if (rate < 0 || rate > 100) {
        return 'Interest rate must be between 0 and 100';
      }
      return true;
    }
    if (fieldCode === 'PERCENTAGE') {
      const percent = parseFloat(newValue);
      if (Number.isNaN(percent)) {
        return 'Please enter a valid percentage';
      }
      if (percent < 0 || percent > 100) {
        return 'Percentage must be between 0 and 100';
      }
      return true;
    }
    if (fieldCode === 'PAN') {
      const panformat = /[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
      if (!panformat.test(newValue)) {
        return 'Please enter a valid PAN number (e.g. ABCDE1234F)';
      }
      return true;
    }
    if (fieldCode === 'GSTIN') {
      const gstinformat = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
      if (!gstinformat.test(newValue)) {
        return 'Please enter a valid GSTIN number';
      }
      return true;
    }
  }

  return newError || true;
}
